import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmBack = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" className="icon-llm-back" data-icon="icon-llm-back" aria-hidden="true" {...props} ref={ref}><path d="M7.5 12.75L3 8.25L7.5 3.75" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/><path d="M7.5 18.75H15.75C17.1424 18.75 18.4777 18.1969 19.4623 17.2123C20.4469 16.2277 21 14.8924 21 13.5C21 12.1076 20.4469 10.7723 19.4623 9.78769C18.4777 8.80312 17.1424 8.25 15.75 8.25H3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/></svg>);
});

IconLlmBack.displayName = 'IconLlmBack';
